export const model = {
    id: null,
    from: "",
    to: "",
    specialty_id: null,
    room_id: null,
    doctor_id: null,
    day: null
};